@if (forgotPasswordForm$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    <div>
      <h5 class="text-muted fw-normal mb-4">
        Password dimenticata? Inserisci la tua email.
      </h5>
      <div>
        <ellf-text-field
          [label]="'Email'"
          [ngrxFormControlState]="form.controls.username"
          [errors]="form.controls.username.errors | ngrxFormsErr"
          [shouldShowError]="form.controls.username.isInvalid && form.controls.username.isSubmitted"
          >
        </ellf-text-field>
      </div>
    </div>
    @if (!(resetPasswordEmailSent$ | ngrxPush)) {
      <div class="mt-3 text-end">
        <button type="submit" class="btn btn-primary">Inviami le istruzioni</button>
      </div>
    }
  </form>
}

@if ((resetPasswordEmailSent$ | ngrxPush)) {
  <div
    class="login-info text-success text-end mt-3"
    >
    Controlla la tua email per resettare la tua password
  </div>
}
